import React, {useState} from "react";
import {Button, ConfirmModal} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";
import {useExistingOrder} from "@widgets/pos/order/hooks/UseExistingOrder";
import {posOrders} from "@/routing/Router";
import {useFormState} from "react-hook-form";
import {PosOrderForm} from "@/data/entities/order";
import {useNavigate} from "react-router-dom";
import {globalConfirmModalProps} from "@/utils/ModalUtils";

type Props = {
    isPending: boolean,
};

const CancelEdit = ({isPending}: Props) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const {isDirty} = useFormState<PosOrderForm>();
    const existingOrder = useExistingOrder();
    const [showConfirmCancelModal, setShowConfirmCancelModal] = useState(false);
    const redirectBack = () => {
        navigate(posOrders(existingOrder?.publicCartId).absolutePath());
    };

    return (
        <>
            <Button
                contentsClassname={"mt-3"}
                variant={"link"}
                width={"w-full"}
                align={"center"}
                disabled={isPending}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: e => {
                            e.preventDefault();

                            if (isDirty) {
                                setShowConfirmCancelModal(true);
                            } else {
                                redirectBack();
                            }
                        },
                    },
                }}
            >
                <FormattedMessage id={"cancelAndReturn"}/>
            </Button>

            <ConfirmModal
                {...globalConfirmModalProps(intl)}
                type={"warning"}
                title={intl.formatMessage({id: "cancelChanges"})}
                show={showConfirmCancelModal}
                onClose={() => setShowConfirmCancelModal(false)}
                dismissButton={{text: intl.formatMessage({id: "no"})}}
                continueButton={{
                    text: intl.formatMessage({id: "confirmCancel"}),
                    onClick: () => {
                        redirectBack();
                    },
                    props: {
                        color: "warning",
                    },
                }}
            >
                <FormattedMessage id={"discardChangesConfirm"}/>
            </ConfirmModal>
        </>
    );
};

export default CancelEdit;